import React, { useState } from 'react';

import Label from '../../../components/Label';

import { toast } from 'react-toastify';
import SeatPicker from 'react-seat-picker';
import { Container, Grid, TextField, Button, Dialog, DialogContent, DialogActions } from '@material-ui/core';

import {
    ContainerBox,
    Content,
    Row,
    Align,
    Margin,
} from './styles';

const Map = ({ nextStep, onChangeRow, prevStep, values }) => {
    const [open, setOpen] = useState(false);
    const [currentButton, setCurrentButton] = useState(<Button>no defined</Button>);
    const [position, setPosition] = useState({
        value: '',
        name: '',
        row: 0,
        id: 0,
        isReserved: false,
        isSelected: false,
    });

    const handleOpen = () => { setOpen(true) };
    const handleClose = () => { setOpen(false) };

    function onChange(event) {
        const { value, name } = event.target;
        console.log(value, name)
        setPosition({ ...position, [name]: value });
        onChangeRow(position.row-1, position.id-1, name, value)
    }

    const nextStepMap = () => {
        let flag = false;
        values.rows.forEach(g => g.forEach( h => { if (h.isSelected && !h.name) flag = h } ))
        if (flag) toast.warn(`Posição ${flag.number} está selecionada mas não possui nome!`)

        let validValues = []
        values.rows.forEach(g => g.forEach( h => { if (h.isSelected && h.name) validValues.push(h.name) } ))
        if (
            (new Set(validValues)).size !== validValues.length
        ) toast.warn(`Existem posições selecionadas com nome duplicados!`)

        else nextStep();
    };

    const addSeatCallback = async ({ row, number, id }, addCb) => {
        handleOpen()
        const data = values.rows[parseInt(row, 10)-1][id-1]
        setPosition({
            id,
            row: parseInt(row, 10),
            name: data.name,
            isSelected: !data.isSelected,
        })
        setCurrentButton(
            <Button
                onClick={() => {
                    onChangeRow(parseInt(row, 10)-1, id-1, 'isSelected', !data.isSelected);
                    addCb(row, number, id);
                    handleClose();
                }}
            >
                marcar assento
            </Button>
        )
    }

    const removeSeatCallback = async ({ row, number, id }, removeCb) => {
        handleOpen()
        const data = values.rows[parseInt(row, 10)-1][id-1]
        setPosition({
            id,
            row: parseInt(row, 10),
            name: data.name,
            isSelected: !data.isSelected,
        })

        setCurrentButton(
            <Button
                onClick={() => {
                    onChangeRow(parseInt(row, 10)-1, id-1, 'isSelected', !data.isSelected);
                    removeCb(row, number);
                    handleClose();
                }}
            >
                desmarcar assento
            </Button>
        )
    }

    const modal = (
        <Dialog
            onClose={handleClose}
            open={open}

        >
            <DialogContent>
                <TextField
                    label="Nome"
                    name="name"
                    onChange={onChange}
                    value={position.name}
                    fullWidth
                />
                <Align>
                    <Label
                        size='nano'
                        color='dark'
                        align='left'
                        weight='700'
                        padding='10px 0'
                    >
                        id: 
                    </Label>
                    <Label
                        size='nano'
                        color='dark'
                        align='right'
                        padding='10px 0'
                    >
                        {position.id}
                    </Label>
                </Align>
                <Align>
                    <Label
                        size='nano'
                        color='dark'
                        align='left'
                        weight='700'
                        padding='10px 0'
                    >
                        number: 
                    </Label>
                    <Label
                        size='nano'
                        color='dark'
                        align='right'
                        padding='10px 0'
                    >
                        {position.row}
                    </Label>
                </Align>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    cancelar
                </Button>
                {currentButton}
            </DialogActions>
        </Dialog>
    )

    return (
        <ContainerBox>
            {modal}
            <Content>
                <Container className="container" maxWidth="md">
                    <Row>
                        <Container className="container" maxWidth="md">
                            <Label
                                size='big'
                                color='dark'
                                align='center'
                                font='Roboto'
                                padding='10px 0 30px'
                            >Defina todas as posições do evento</Label>
                            <SeatPicker
                                addSeatCallback={addSeatCallback}
                                removeSeatCallback={removeSeatCallback}
                                rows={values.rows}
                                maxReservableSeats={values.count_rows * values.count_columns}
                                alpha={false}
                                visible
                                selectedByDefault
                                tooltipProps={{multiline: true}}
                            />
                        </Container>
                    </Row>
                </Container>
                <div>
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={prevStep}
                    >anterior</Button>
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={nextStepMap}
                    >próximo</Button>
                </div>
            </Content>
        </ContainerBox>
    )
}

export default Map;
